import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import PublicUserRoutes from "../routing/public-user-routes";
import { showHeader, showFooter, setFooterType, setHeaderType, showFloatingMenus } from "../globals/layout-config";
import AnnouncementBar from "../app/pannels/public-user/components/common/AnnouncementBar";

const FloatingMenus = lazy(() => import("../app/common/floating/floatingMenu"));
const SignUpPopup = lazy(() => import("../app/common/popups/popup-signup"));
const SignInPopup = lazy(() => import("../app/common/popups/popup-signin"));

function PublicUserLayout() {
    const currentpath = useLocation().pathname;
    return (
        <>
            <div className="page-wraper">

                {/* ── Porsche-style Digital Domain announcement bar ── */}
                <AnnouncementBar digitalDomainUrl="https://studio.unicx.in/" />

                {
                    showFloatingMenus(currentpath) &&
                    <Suspense fallback={null}>
                        <FloatingMenus />
                    </Suspense>
                }

                {/* Header */}
                {
                    showHeader(currentpath) &&
                    <Suspense fallback={null}>
                        {setHeaderType(currentpath)}
                    </Suspense>
                }

                <div className="page-content">
                    {/* {
                        showBanner(currentpath) &&
                        <InnerPageBanner _data={setBanner(currentpath)} />
                    } */}
                    <PublicUserRoutes />
                </div>

                {/* Footer */}
                {
                    showFooter(currentpath) &&
                    <Suspense fallback={null}>
                        {setFooterType(currentpath)}
                    </Suspense>
                }

                {/* BUTTON TOP START */}
                <button className="scroltop"><span className="fa fa-angle-up  relative" id="btn-vibrate" /></button>

                <Suspense fallback={null}>
                    <SignUpPopup />
                    <SignInPopup />
                </Suspense>

            </div>
        </>
    )
}

export default PublicUserLayout;
